// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8j-4";
export var collapsed = "_8j-1";
export var headerBar = "_8j-0";
export var leftHeaderContent = "_8j-3";
export var subjectContainer = "_8j-2";